import { useEventListener } from './useEventListener'

export function useBeforeUnload(message: string | (() => string | undefined)): void {
  useEventListener(window, 'beforeunload', (event) => {
    if (event.defaultPrevented) {
      return
    }

    const actualMessage = typeof message === 'function' ? message() : message

    if (actualMessage === undefined) {
      return
    }

    event.returnValue = actualMessage
    return event.returnValue
  })
}
